import { useCountdown } from "@/utils/useCountdown"

export function Counter({ dataFim }: Readonly<{ dataFim: string }>) {
    const { dias, horas, minutos, segundos } = useCountdown(dataFim)
        
    if (!dataFim) return null
    
    return (
        <div className="oferta-countdown">
            <div
                data-fim={dataFim}
                data-diff-days="true"
            >
                <div className="text-contador">Corra, a oferta acaba em:</div>

                <div className="alinha-contador">
                    {Number(dias) > 0 && (
                        <div className="ctn dia">
                            <span className="count">{dias}d</span>
                            <span className="text">:</span>
                        </div>
                    )}
                    <div className="ctn hora">
                        <span className="count">{horas}h</span>
                        <span className="text">:</span>
                    </div>
                    <div className="ctn min">
                        <span className="count">{minutos}m</span>
                        <span className="text">:</span>
                    </div>
                    <div className="ctn seg">
                        <span className="count">{segundos}s</span>
                    </div>
                </div>
            </div>
        </div>
    )
}